<template>
  <div class="login">
    <div class="container">
      <div class="card card-container">
        <form class="form-signin">
          <div class="row">
            <h2>Login</h2>
            <h4>Thaivivat Health Care Sales Portal</h4>
            <div class="img-hd-login"></div>

            <div class="col-sm-12 no-padd">
              <div class="col-sm-2 col-xs-2 no-padd">
                <img
                  id="profile-img"
                  class="img-logo-btn-tmb"
                  src="../assets/images/logo/logo_ttb.png"
                />
              </div>
              <div class="col-sm-10 col-xs-10 pd-bt">
                <router-link to="tmblogin">
                  <button
                    class="btn btn-lg btn-primary btn-tmb btn-block"
                    style="background: #0050f0 !important; border-color: #0279c1 !important;"
                    type="submit"
                  >
                    Login ttb
                  </button>
                </router-link>
              </div>
            </div>

            <div v-if="is_error_login != null">
              <h5 class="text-danger">
                <i class="fa fa-warning m-r-xs"></i>
                เกิดข้อผิดพลาด : {{ is_error_login }}
              </h5>
            </div>
          </div>

          <router-link
            to="tvilogin"
            style="position: absolute;
            right: 10px;
            bottom: 0px;"
          >
            <button class="btn btn-link" type="submit" style="color:#888;">LOGIN THAIVIVAT</button>
          </router-link>
        </form>
      </div>
      <!-- /card-container -->

      <!-- <div class="row" style="padding-top:10%;margin:auto;">
        <img class="profile-img-card" src="../assets/images/logo_profile.jpg" alt="" />
        <h2 class="text-light m-t-lg">ขออภัยระบบกำลังปิดปรับปรุงวันที่ 2 กันยายน เวลา 20.00น - วันที่ 3 กันยายน เวลา 8.00น.   </h2>
      </div> -->
    </div>
    <!-- /container -->
  </div>
</template>

<style lang="scss" scoped>
@import '../styles/login';
</style>

<script>
export default {
  name: 'login',
  data() {
    return {
      data: {},
      is_error_login: null,
    }
  },
  mounted() {
    this.$swal.close()
    if (this.$session.has('error')) {
      //console.log(this.$session.get("error"));
      this.is_error_login = this.$session.get('error').msg
    }
  },
  computed: {},
  components: {},
  methods: {},
}
</script>
